const czech = {
    'PHOTO_SOURCE.TakePhoto' : 'Pořídit fotografii',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Vybrat z galerie',
    'CRAFT.Type_Logistics' : 'Logistika { number }',
    'CRAFT.Type_Floor' : 'Podlaha { number }',
    'CRAFT.Type_Assembly' : 'Montáž { number }',
    'CRAFT.Type_Electrics' : 'Elektro { number }',
    'CRAFT.Type_Graphic' : 'Grafika { number }',
    'CRAFT.Type_Furniture' : 'Nábytek { number }',
    'CRAFT.Type_Multimedia' : 'Multimédia { number }',
    'CRAFT.Type_Cleaning' : 'Úklid { number }',
    'CRAFT.Type_Additional' : 'Dodatečné { number }',
    'CRAFT.Type_MPControl' : 'MP kontrola',
    'CRAFT.Type_Protocol' : 'Protokol',
    'CRAFT.Type_Service' : 'Servis { number }',
    'CRAFT.Type_CollectGraphics' : 'Vyzvednout grafiku',
    'CRAFT.Status_Text_InProgress' : 'Probíhá',
    'CRAFT.Status_Text_Disabled' : 'Vypnuto',
    'CRAFT.Status_Text_Completed' : 'Dokončeno',
    'CRAFT.Status_Text_Overdue' : 'Po termínu',
    'CRAFT.Status_Text_Done' : 'Vyzvednuto',
    'CRAFT.Status_Text_Open' : 'Otevřeno',
    'CRAFT.Status_Text_Collected': 'Vyzvednuto',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Stav nelze změnit: grafika již byla zpracována v administraci',
    'CRAFT.Button_ViewAll' : 'Zobrazit vše',
    'CRAFT.Button_Text_Print' : 'Tisk',
    'CRAFT.Button_Text_Stand' : 'Stánek',
    'CRAFT.Button_Text_MarkOpen' : 'Označit práci jako otevřenou',
    'CRAFT.Button_Text_MarkDone' : 'Označit práci jako hotovou',
    'CRAFT.Button_Text_MarkInProgress' : 'Označit práci jako probíhající',
    'CRAFT.Button_ChangeStatus_InProgress' : 'Probíhá',
    'CRAFT.Button_ChangeStatus_Done': 'Hotovo',
    'CRAFT.Button_Text_ShelfNumber' : 'Č. police',
    'CRAFT.Filter_Params_CraftType' : 'Práce: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Vyberte akci { br } ze seznamu níže',
    'EXHIBITION.Select_Label' : 'VYBRANÁ AKCE',
    'EXHIBITION.Modal_Title' : 'VYBERTE AKCI',
    'EXHIBITION.Timer_State_Underway' : 'PROBÍHÁ',
    'EXHIBITION.Timer_State_Ended' : 'UKONČENO',
    'EXHIBITION.Title_CraftTotal' : 'Přehled všech prací',
    'EXHIBITION.Statistic_Status_InTotal' : 'celkem',
    'EXHIBITION.Statistic_Status_InProgress' : 'probíhá',
    'EXHIBITION.Statistic_Status_Done' : 'hotovo',
    'EXHIBITION.Statistic_Status_Overdue' : 'po termínu',
    'EXHIBITION.Statistic_Status_NotApproved' : 'neschváleno',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'přiřazeno k výstavě',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Přihlášeni',
    'EXHIBITION.Statistic_Type_Stands' : 'Stánky',
    'EXHIBITION.Statistic_Type_Claims' : 'MP reklamace',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Reklamace vystavovatele',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Urgentní úkoly',
    'EXHIBITION.Statistic_Type_MpControl' : 'MP kontrola',
    'EXHIBITION.Statistic_Type_Damages' : 'Škody',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protokol',
    'EXHIBITION.Statistic_Type_Staff' : 'Personál',
    'FORM.Textarea_Placeholder_JobDescription' : 'Popis úkolu*',
    'FORM.Button_Text_AddJob' : 'Přidat úkol',
    'FORM.Button_Text_SaveJob' : 'Uložit úkol',
    'FORM.Button_AddJobPhoto' : 'Přidat fotku',
    'FORM_RULES.Required_Login' : 'Zadejte login',
    'FORM_RULES.Required_Password' : 'Zadejte heslo',
    'FORM_RULES.Required_KeyDescription' : 'Zadejte popis klíče',
    'FORM_RULES.Required_KeyNumber' : 'Zadejte číslo klíče',
    'FORM_RULES.Required_JobDescription' : 'Přidejte popis úkolu',
    'FORM_RULES.Required_Quantity' : 'Zadejte množství',
    'FORM_RULES.Min_Quantity' : 'Množství musí být číslo nejméně jedna',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'heslo',
    'FORMS.Button_Text_Login' : 'Přihlásit',
    'FORMS.Input_Label_Description' : 'Popis',
    'FORMS.Input_Label_KeyNumber' : 'Číslo klíče',
    'FORMS.Input_Label_Hall' : 'Hala',
    'FORMS.Input_Label_Stands' : 'Stánky',
    'FORMS.Button_Text_ApplyFilters' : 'Použít',
    'FORMS.Button_Text_ResetFilters' : 'Resetovat filtry',
    'FORMS.Select_DefaultValue_All' : 'Vše',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'S probíhajícími pracemi',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'S dokončenými pracemi',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'S probíhající kontrolou',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'S probíhajícím protokolem',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'S pracemi po termínu',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'S dodatečnými úkoly',
    'FORMS.Button_Text_ApplySort' : 'Použít',
    'FORMS.Input_Label_CraftType' : 'Typ práce',
    'FORMS.Input_Label_JobType'   : 'Typ',
    'FORMS.Input_Label_JobFlag'   : 'Příznak',
    'FORMS.Input_Label_JobStatus' : 'Stav',
    'FORMS.Input_Label_CraftStatus' : 'Stav prací',
    'FORMS.Input_Label_DamageStatus' : 'Stav škody',
    'FORMS.Input_Label_Subcontractor' : 'Subdodavatel',
    'FORMS.Input_Label_Comments' : 'Komentáře',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Otevřené úkoly',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Probíhající úkoly',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Dokončené úkoly',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Bez příznaku',
    'FORMS.Select_JobFlag_WithFlag' : 'S příznakem',
    'FORMS.Input_Label_FurnishingName' : 'Název vybavení',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Množství',
    'FORMS.Input_Label_Quantity' : 'Množství',
    'FORMS.Input_Label_CurrentQuantity' : 'Aktuální množství',
    'FORMS.Input_Label_NewQuantity' : 'Nové množství',
    'FORMS.RadioInput_Text_Description' : 'Popis',
    'FORMS.RadioInput_Text_Furnishing' : 'Vybavení',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Vybavení',
    'FORMS.Input_Label_OrderType'   : 'Typ',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Vrácení položky",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Ztraceno",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Změna součtu",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Objednávka",
    'GLOBAL.Button_Text_Logout' : 'Odhlásit',
    'GLOBAL.Button_Text_Filter' : 'Filtr',
    'GLOBAL.Button_Text_Sort' : 'Seřadit',
    'GLOBAL.Text_Version' : 'Verze { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Zrušit',
    'ATTENDANCE.Button_CheckIn': 'Příchod',
    'ATTENDANCE.Button_CheckOut': 'Odchod',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Nejprve vyberte výstavu.',
    'ATTENDANCE.Button_RetryScan': 'Skenovat znovu',
    'ATTENDANCE.Button_Close': 'Zavřít',
    'ATTENDANCE.Modal_Title_CheckIn': 'Skenovat příchod',
    'ATTENDANCE.Modal_Title_CheckOut': 'Skenovat odchod',
    'ATTENDANCE.Scanner_Hint': 'Namiřte kameru na QR kód',
    'ATTENDANCE.Processing_Locating_Title': 'Kontroluje se poloha...',
    'ATTENDANCE.Processing_Locating_Text': 'Čekejte prosím. Hledá se GPS.',
    'ATTENDANCE.Processing_Submitting_Title': 'Odesílá se sken...',
    'ATTENDANCE.Processing_Submitting_Text': 'Čekejte prosím. Ukládá se pracovní čas.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Je vyžadován přístup k poloze',
    'ATTENDANCE.Error_GpsPermission_Text': 'Povolte v prohlížeči přístup k poloze a zkuste to znovu.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Slabý GPS signál',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Souřadnice se nepodařilo zjistit. Jděte blíže k východu a skenujte znovu.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS není dostupné',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Údaje o poloze nejsou na tomto zařízení dostupné.',
    'ATTENDANCE.Error_Camera_Title': 'Kamera není dostupná',
    'ATTENDANCE.Error_Camera_Text': 'Povolte přístup ke kameře a zkuste to znovu.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Přístup ke kameře je zablokován',
    'ATTENDANCE.Error_CameraPermission_Text': 'Povolte přístup ke kameře v nastavení stránky v prohlížeči a zkuste to znovu.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Kamera nebyla nalezena',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Toto zařízení neposkytuje prohlížeči dostupnou kameru.',
    'ATTENDANCE.Error_SecureContext_Title': 'Je vyžadováno HTTPS',
    'ATTENDANCE.Error_SecureContext_Text': 'Kamera a GPS v mobilním prohlížeči fungují pouze přes HTTPS. Otevřete aplikaci přes HTTPS/dev tunnel.',
    'ATTENDANCE.Error_Server_Title': 'Sken selhal',
    'ATTENDANCE.Error_Server_Text': 'Server sken nezpracoval. Zkontrolujte připojení k internetu a zkuste to znovu.',
    'ATTENDANCE.Error_Generic_Title': 'Sken selhal',
    'ATTENDANCE.Error_Generic_Text': 'Zkuste to znovu.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Příchod byl úspěšný',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Odchod byl úspěšný',
    'ATTENDANCE.Result_Accepted_Text': 'Čas: { serverTime }. Jste zaznamenáni v systému.',
    'ATTENDANCE.Result_Duplicate_Title': 'Již zaznamenáno',
    'ATTENDANCE.Result_Duplicate_Text': 'Tento sken již byl uložen.',
    'ATTENDANCE.Result_Rejected_Title': 'Přístup zamítnut',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Jste příliš daleko od vchodu. Jděte blíže ke vchodu.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Tento QR kód není platný pro příchod/odchod.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Sken byl zamítnut.',
    'ATTENDANCE.Button_Back': 'Zpět',
    'ATTENDANCE.Button_TryAgain': 'Zkusit znovu',
    'ATTENDANCE.Button_GotIt': 'Rozumím',
    'ATTENDANCE.Overview_NotCheckedIn': 'Příchod není zaznamenán',
    'ATTENDANCE.Overview_CheckInPrompt': 'Zaznamenejte příchod pomocí QR kódu',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Příchod zaznamenán',
    'ATTENDANCE.Overview_CheckedInAt': 'v { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Před zahájením práce naskenujte QR kód pro zaznamenání příchodu',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Pro odchod namiřte kameru na QR kód na výstavě',
    'ATTENDANCE.Error_StatusLoad_Text': 'Stav příchodu se nepodařilo načíst.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Aplikace nemůže otevřít kameru',
    'ATTENDANCE.Error_CameraDesign_Text': 'Pro příchod naskenujte kód kamerou telefonu. Klepněte na Zkusit znovu a povolte přístup ke kameře.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Stále to nefunguje? Zkontrolujte oprávnění kamery v nastavení prohlížeče.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Aplikace nevidí vaši polohu',
    'ATTENDANCE.Error_LocationDesign_Text': 'Pro potvrzení přítomnosti je potřeba poloha. Zapněte ji v nastavení telefonu a zkuste to znovu.',
    'ATTENDANCE.Result_CheckedInAt': 'Příchod zaznamenán dne { date }. v { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Příchod do práce byl úspěšně zaznamenán v { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Práci jste ukončili a odchod{ br }zaznamenali v { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Musíte být v místě konání',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Vaše poloha neodpovídá výstavě. Příchody se zaznamenávají pomocí GPS. Zkuste to znovu na správném místě.',
    'ATTENDANCE.Result_InvalidQr_Title': 'Toto není správný kód',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Příchod nelze zaznamenat!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Odchod nelze zaznamenat!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Tento QR kód nepatří k vaší akci. Obraťte se prosím na vedení stavby nebo projektu.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Příchod nelze zaznamenat!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Jiná osoba již zaznamenala svůj příchod pomocí tohoto telefonu. Aplikace neumožňuje dvěma různým uživatelům zaznamenat příchod pomocí stejného zařízení!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Skenování příchodu není možné!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Příchod lze zaznamenat pouze během stanoveného období konání akce. Obraťte se prosím na vedení stavby nebo projektu.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Odchod nyní nelze zaznamenat',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Tato akce je dostupná pouze během nastaveného období výstavy. Zkontrolujte vybranou výstavu a její data.',
    'ATTENDANCE.TimeRecords_InProgress': 'probíhá',
    'ATTENDANCE.TimeRecords_Missed': 'chybí',
    'ATTENDANCE.TimeRecords_Empty': 'Zatím nejsou žádné časové záznamy.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Časové záznamy se nepodařilo načíst.',
    'MENUS.Label_MyTimeRecords': 'Moje časové záznamy',
    'PAGE.Title_MyTimeRecords': 'Moje časové záznamy',
    'GLOBAL.Badge_Text_New' : 'NOVÉ',
    'GLOBAL.Modal_Title_Filters' : 'Filtry',
    'GLOBAL.Modal_Title_SortBy' : 'Seřadit podle',
    'GLOBAL.TimeLeft' : 'zbývá { timeLeft }',
    'GLOBAL.Text_Piece' : 'ks',
    'GLOBAL.Button_Text_Confirm' : 'Potvrdit',
    'GLOBAL.Language_Default' : 'Výchozí',
    'TRANSLATION.Button_Text_Translate' : 'Přeložit',
    'TRANSLATION.Button_Text_TranslateInput' : 'Přeložit do němčiny',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Přeložit do angličtiny',
    'TRANSLATION.Button_Text_TranslateNative' : 'Přeložit do mého jazyka',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Zobrazit německý originál',
    'TRANSLATION.Text_InputTranslating' : 'Překládá se...',
    'TRANSLATION.Text_InputTranslated' : 'Přeloženo',
    'TRANSLATION.Text_InputTranslationError' : 'Překlad se nezdařil',
    'TRANSLATION.Text_InputTranslationRequired' : 'Před odesláním text přeložte',
    'TRANSLATION.Text_ApiUnavailable' : 'Překlad nyní není dostupný',
    'GLOBAL.Card_Hero_Hall' : 'Hala',
    'GLOBAL.Card_Hero_Block' : 'Blok',
    'GLOBAL.Card_Hero_Stand' : 'Stánek',
    'GLOBAL.Comment': 'Komentář',
    'HALL.Button_Text_HallPlan' : 'Plán haly',
    'HALL.Link_Text_HallPlan' : 'Plán haly { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hala',
    'JOB.Card_Hero_Number' : 'Č. úkolu',
    'JOB.Card_Hero_Block' : 'Blok',
    'JOB.Card_Hero_Stand' : 'Stánek',
    'JOB.Card_Hero_Exhibitor' : 'Vystavovatel',
    'JOB.Button_Text_ToTheStand' : 'Ke stánku',
    'JOB.Text_Creator' : 'od { whoCreate } dne { whenCreate }',
    'JOB.Text_InWork' : 'od { whoWork } dne { whenWork }',
    'JOB.Text_Executor' : 'od { whoExecute } dne { whenExecute }',
    'JOB.Text_DurationTime' : 'Doba trvání: { time }',
    'JOB.Type_Claim' : 'MP reklamace',
    'JOB.Type_AllClaims' : 'Reklamace',
    'JOB.Type_CustomerClaim' : 'Reklamace vystavovatele',
    'JOB.Type_LastMinute' : 'Urgentní úkol',
    'JOB.Type_Damage' : 'Škoda',
    'JOB.Type_ProtocolDefect' : 'Vada v protokolu',
    'JOB.Button_ChangeStatus_Waiting' : 'Převzít úkol',
    'JOB.Button_ChangeStatus_InProgress' : 'Úkol probíhá',
    'JOB.Button_ChangeStatus_Done' : 'Dokončit úkol',
    'JOB.Modal_Title_Photo' : 'Fotka úkolu',
    'JOB.Filter_Params_JobType' : 'Typ: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Práce: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nový { jobType }',
    'JOB.Modal_Title_EditJob' : 'Upravit { jobType }',
    'JOB.Button_Text_AddClaim' : 'Přidat úkol MP reklamace',
    'JOB.Button_Text_AddCustomerClaim' : 'Přidat úkol reklamace vystavovatele',
    'JOB.Button_Text_AddLastMinute' : 'Přidat urgentní úkol',
    'JOB.Button_Text_AddDamage' : 'Přidat fotku škody',
    'JOB.Button_Text_AddProtocolDefect' : 'Přidat vadu protokolu',
    'DAMAGE.Card_Title' : 'Škody u { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Škody { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Nezkontrolováno',
    'DAMAGE.Status_Label_Check' : 'Zkontrolováno',
    'DAMAGE.Status_Label_DCheck' : 'Schváleno',
    'DAMAGE.Button_Text_Stand' : 'Stánek',
    'DAMAGE.Button_Text_Photo' : 'Fotka',
    'DAMAGE.Button_Text_AddNote' : "PŘIDAT POZNÁMKU",
    'DAMAGE.Modal_Button_AddPhoto' : 'Přidat fotku',
    'DAMAGE.Modal_Button_CreateReport' : 'Vytvořit report',
    'DAMAGE.Modal_Button_EditReport' : 'Upravit report',
    'DAMAGE.AsCraft_label' : "Škody",
    "DAMAGE.Button_Text_Open" : "Otevřít",
    "STAND.Block_Title_Damages" : "Škody",
    'MENUS.Label_Overview' : 'Přehled',
    'MENUS.Label_Stands' : 'Stánky',
    'MENUS.Label_Jobs' : 'Úkoly',
    'MENUS.Label_ExpoPlan' : 'Plán expo',
    'MENUS.Label_More' : 'Více',
    'MENUS.Label_SelectExhibition' : 'Vybrat akci',
    'MENUS.Label_CraftsOverview' : 'Přehled prací',
    'MENUS.Label_HallsOverview' : 'Přehled hal',
    'MENUS.Label_ViewDamages' : 'Zobrazit škody',
    'MENUS.Label_Downloads' : 'Soubory',
    'MENUS.Label_Documents' : 'Dokumenty',
    'MENUS.Label_FurnishingLeftovers' : 'Zbylé vybavení',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Vyzvednout grafiku',
    'NO_DATA.Exhibitions' : 'Zatím nemáte žádné akce.',
    'NO_DATA.Documents' : 'Aktuální akce zatím nemá { br } žádné dokumenty.',
    'NO_DATA.Stands' : 'Stánky odpovídající požadavku { br } nebyly nalezeny',
    'NO_DATA.StandPhoto' : 'Zatím nemáte fotku stánku',
    'NO_DATA.DamagePhoto' : 'Zatím nemáte fotku škod { br } tohoto stánku',
    'NO_DATA.Stand_NoKeys' : 'Tento stánek zatím nemá žádné klíče',
    'NO_DATA.Stand_DoesNotExist' : 'Tento stánek neexistuje',
    'NO_DATA.Subcontractor_Unsigned' : 'Nepřiřazeno',
    'NO_DATA.Jobs' : 'Úkoly odpovídající požadavku { br } nebyly nalezeny',
    'NO_DATA.Damages' : 'Škody odpovídající požadavku { br } nebyly nalezeny',
    'NO_DATA.Hall' : 'Tato hala neexistuje',
    'NO_DATA.HallPlan' : 'Nenašli jsme plán této haly',
    'NO_DATA.Furnishing_Storage' : 'Tato akce nemá { br } vybavení ve skladu',
    'NO_DATA.Furnishing_Orders' : 'Tato akce nemá { br } objednávky vybavení',
    'PAGE.Title_Overview' : 'Přehled',
    'PAGE.Title_ExhibitionSelection' : 'Výběr akce',
    'PAGE.Title_Stands' : 'Stánky',
    'PAGE.Title_Stand' : 'Stánek',
    'PAGE.Title_StandComments' : 'Komentáře stánku',
    'PAGE.Title_StandLog' : 'Log stánku',
    'PAGE.Title_StandKeys' : 'Klíče stánku',
    'PAGE.Title_ViewDamages' : 'Zobrazit škody',
    'PAGE.Title_AdditionalMenu' : 'Další menu',
    'PAGE.Title_Jobs' : 'Úkoly',
    'PAGE.Title_ExpoPlan' : 'Plán expo',
    'PAGE.Title_Documents' : 'Dokumenty',
    'PAGE.Title_FurnishingLeftovers' : 'LM vybavení',
    'PAGE.Title_FurnishingReturns' : 'Záznam změn vybavení',
    'PAGE.Title_HallPlan' : 'Plán haly',
    'PAGE.Title_HallsOverview' : 'Přehled hal',
    'PAGE.Title_CraftsOverview' : 'Přehled prací',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Vyzvednout grafiku',
    'SORT.Text_NewestByCreation' : 'Nejnovější podle data vytvoření',
    'SORT.Text_OldestByCreation' : 'Nejstarší podle data vytvoření',
    'SORT.Text_ExhibitorNameAZ' : 'Název vystavovatele (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Název vystavovatele (Z-A)',
    'SORT.Text_FinishedFirst' : 'Dokončené první',
    'SORT.Text_InProgressFirst' : 'Otevřené první',
    'SORT.Text_StandNumberAZ' : 'Číslo stánku (A-Z)',
    'SORT.Text_StandNumberZA' : 'Číslo stánku (Z-A)',
    'SORT.Text_CorridorAZ' : 'Koridor (A-Z)',
    'SORT.Text_CorridorZA' : 'Koridor (Z-A)',
    'SORT.Text_BlockAZ' : 'Blok (A-Z)',
    'SORT.Text_BlockZA' : 'Blok (Z-A)',
    'SORT.Text_FlagFirst' : 'S příznakem první',
    'SORT.Text_FlagLast' : 'Bez příznaku první',
    'SORT.Text_HallAZ' : 'Hala (A-Z)',
    'SORT.Text_HallZA' : 'Hala (Z-A)',
    'SORT.Text_StatusAZ' : 'Schváleno',
    'SORT.Text_StatusZA' : 'Nezkontrolováno',
    'STAND.Modal_Title_Search' : 'Hledat',
    'STAND.Input_Placeholder_Search' : 'Hledat',
    'STAND.Filter_Params_Exhibitor' : 'Vystavovatel: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'S komentáři',
    'STAND.Card_Hero_Hall' : 'Hala',
    'STAND.Card_Hero_Block' : 'Blok',
    'STAND.Card_Hero_Stand' : 'Stánek',
    'STAND.Card_Hero_DeliveryTime' : 'Čas dodání',
    'STAND.Modal_Title_StandPlan' : 'Výkres stánku',
    'STAND.Modal_Button_StandPlan' : 'Výkres',
    'STAND.Card_Button_Details' : 'Detaily { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Fotka stánku',
    'STAND.Modal_Button_StandPhoto' : 'Fotka',
    'STAND.Modal_Button_SavePhoto' : 'Uložit fotku',
    'STAND.Modal_Button_AddPhoto' : 'Přidat fotku',
    'STAND.Button_Text_Comments' : 'Komentáře',
    'STAND.Button_Text_AddComment' : 'Přidat komentář',
    'STAND.Modal_Title_AddComment' : 'Přidat komentář',
    'STAND.Modal_Title_EditComment' : 'Upravit komentář',
    'STAND.Modal_Button_AddComment' : 'Přidat',
    'STAND.Modal_Button_SaveComment' : 'Uložit',
    'STAND.Text_NoComments' : 'Zatím nejsou žádné komentáře',
    'STAND.Text_AddFile' : 'Přidat soubor',
    'COMMENTS.Text_Uploading' : 'Nahrávání...',
    'STAND.Text_EditComment' : 'Upravit',
    'STAND.Text_DeleteComment' : 'Smazat',
    'STAND.Text_CommentDraftError' : 'Koncept komentáře ještě není připraven',
    'STAND.Block_Title_Overview' : 'Přehled',
    'STAND.Block_Title_Materials' : 'Doplňující informace',
    'STAND.Block_Title_Crafts' : 'Práce',
    'STAND.Block_ItemTitle_Hall' : 'Hala',
    'STAND.Block_ItemTitle_Block' : 'Blok',
    'STAND.Block_ItemTitle_Stand' : 'Stánek',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Číslo Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Úkoly',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } probíhá',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } otevřené',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } dokončené',
    'STAND.Block_Button_ViewStandJobs' : 'Zobrazit úkoly stánku',
    'STAND.Modal_Title_StandGraphic' : 'Grafika stánku',
    'STAND.Modal_Button_StandGraphic' : 'Grafika stánku',
    'STAND.Modal_Title_ExtraInfo' : 'Extra info',
    'STAND.Modal_Button_ExtraInfo' : 'Extra info',
    'STAND.Button_Text_ViewKeys' : 'Zobrazit klíče',
    'STAND.Button_Text_ViewLogs' : 'Zobrazit logy',
    'STAND.Modal_Button_AddKey' : 'Přidat klíč',
    'STAND.Modal_Title_AddKey' : 'Přidat klíč',
    'STAND.Modal_Title_EditKey' : 'Upravit klíč',
    'STAND.Modal_Button_UpdateKey' : 'Aktualizovat klíč',
    'STAND.Filter_Params_Stand' : 'Stánek { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Smazat',
    'STAND.Text_ModalDelete_Question' : 'Opravdu chcete smazat klíč { keyName }?',
    'STAND.External_Exhibition' : 'Akce, ke které nejste přiřazeni',
    'JOB.Button_Text_ViewPhoto' : 'Zobrazit fotku',
    'OVERVIEW_TYPES.Label_InTotal' : 'celkem',
    'OVERVIEW_TYPES.Label_Finished' : 'dokončeno',
    'OVERVIEW_TYPES.Label_Open' : 'otevřeno',
    'OVERVIEW_TYPES.Label_Claims' : 'reklamace',
    'OVERVIEW_TYPES.Label_LastMinute' : 'urgentní',
    'OVERVIEW_TYPES.Label_Overdue' : 'po termínu',
    'FURNISHING.TabName_Storage' : 'Sklad',
    'FURNISHING.TabName_Refund' : 'Vrácení',
    'FURNISHING.TabName_OrderLog' : 'Záznam objednávek',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Množství LM vybavení',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Vybavení ve skladu',
    'FURNISHING.Button_Text_Return' : 'Vrátit',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Vybrat vybavení',
    'FURNISHING.Modal_Title_Photo' : "Fotka vybavení",
    'FURNISHING.Order_Type_Refund' : "Vrácení",
    'FURNISHING.Order_Type_Lost' : "Ztraceno",
    'FURNISHING.Order_Type_Correction' : "Oprava",
    'FURNISHING.Order_Type_Order' : "Objednávka",
};

export default czech;
